/**
 * Build the AVIF variant of an image url, or null when it must not be used.
 *
 * plentymarkets only generates .avif files for item images (path segment
 * /item/images/). Assets below /frontend/ have no AVIF variant and answer with
 * 403. That distinction matters wherever the url ends up in a <picture>: the
 * element does NOT fall back to the next <source> when a source fails to load,
 * the choice is made solely by the type attribute. A blanket .avif would
 * therefore break the language flags and the footer icons.
 *
 * Gated on the same switch current Ceres reads - "Automatische Konvertierung in
 * moderne Bildformate (AVIF, WebP)" under Logging und Performance. With the
 * option off plenty stops generating the files and every .avif url would 403.
 *
 * @param {string} url
 * @returns {string|null}
 */
export function avifUrl(url)
{
    if (typeof App === "undefined" || !App.config || !App.config.log || !App.config.log.modernImagesConversion)
    {
        return null;
    }

    if (!url || url.indexOf("/item/images/") === -1)
    {
        return null;
    }

    const parts = url.split("?");
    const path = parts[0];
    const query = parts[1];

    // Never stack converted formats - .webp.avif does not exist
    if ((/\.(avif|webp)$/i).test(path))
    {
        return null;
    }

    return query ? `${path}.avif?${query}` : `${path}.avif`;
}
